import { Injectable } from '@angular/core';
import { decodeUtf8, encodeUtf8, isInArrayKey } from '@core/_utils/tools.utils';
import { TreeNode } from 'primeng/api';
import { MessagesService } from '@core/_services/messages.service';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from './apiv6.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class TreeService {
    public openPath = '';
    public prevExpand = 0;
    public lastExpand = 0;
    public lastNode : TreeNode;
    public root: string = '';
    public path: string = '';
    public filterTree: string = '';
    public loadRootFailed: boolean = false;
    public execAuto: boolean = false;
    public requestFailed: boolean = false;
    constructor(
        protected _messageService: MessagesService,
        private api: ApiV6Service,
        private translate: TranslateService,
    ) {
        this.openPath = '';
        this.init();
    }

    public init() {
        this.root = '';
        this.path = '';
        this.filterTree = '';        
        this.execAuto = false;
        this.requestFailed = false;
    }

    public async loadRoot(aRoot, aTreeIndex, call) {
        let wRes: any;
        let wIsLoaded = false;
        let wRoot = '';
        let wKey = '';
        let wIndex = 0;
        this.loadRootFailed = false;
        for (let i = 0; i < aTreeIndex.length; i++) {
            if (aTreeIndex[i].label === aRoot) {
                wIndex = i;
                wIsLoaded = aTreeIndex[i].loaded;
                wRoot = aTreeIndex[i].label;
                wKey = aTreeIndex[i].key;
                break;
            }
        }
        if (wIsLoaded === false) {            
            wRes = await this.execExpand(wRoot, wKey, call);
            if (wRes !== undefined) {
                aTreeIndex[wIndex].children = wRes.children;
                aTreeIndex[wIndex].loaded = true;   
            } else {
                this.loadRootFailed = true;
            }
        }
    }

    public async execExpand(aRoot, key, call) {
        let wRes;
        let wNode = <any>[];
        const wParams = { 
            FilterRoot: aRoot, Prefix: key };
        try {
            call(true);
            wRes = await lastValueFrom(this.api.execUrlAction('getchildroot', wParams));
            wNode = JSON.parse(wRes.base.result);
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }            
        finally {
            call(false);
        }
        return wNode;
    }

    public async getLoadTree() {
        let wRes: any = {};
        const wParams = { 
            allRoot: false,
            onlyRoot: true
        };
        this.requestFailed = false;
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getrootlist', wParams));
        } catch (error) {
            this.requestFailed = true;
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        return wRes.data;
    }

    public updateTreeSearch(aData) {
        if (aData !== undefined) {
            return this.getTree(aData);
        }
    }

    public async nodeExpand(event, call) {
        let wRes;
        if ((event.node.parent !== null && event.node.parent !== undefined) || event.node.loaded === true) {
            return;
        }
        wRes = await this.execExpand(event.node.label, event.node.key, call);
        if (wRes !== undefined) {
            event.node.children = wRes.children;
            event.node.loaded = true;
        }
    }

    public rootIsPresent(aRoot, aTreeIndex ) {
        if (isInArrayKey(aRoot, aTreeIndex, 'label') !== undefined) {
            return true;            
        } else {
            return false;
        }
    }

    public getPathClick(anode, apath) {
        let path = '';
        if (anode.parent !== undefined && anode.parent !== null) {            
            path = this.getPathClick(anode.parent, anode.label + '/');
        } else {
            path = anode.label + '/';
        }
        path = path + apath;
        return path;
    }

    public getTree(data) {
        let datajson = JSON.parse(decodeUtf8(data));
        if (datajson.data !== undefined && datajson.data !== null) {
            return this.initTree(datajson.data);
        } else {
            return this.initTree([datajson]);
        }
    }

    public initTree(data) {
        let wdataList = new Array();
        for (let i = 0; i < data.length; i++) {
            this.initializeTree(data[i]);
            this.setPath(data[i], data[i].label + '\\');
            wdataList.push(data[i]);
        }
        return wdataList;
    } 

    public updateFromPath(data) {        
        let wdataList = new Array();
        for (let i = 0; i < data.length; i++) {
            this.updateTreeFromPath(data[i], null);            
            this.setPath(data[i], data[i].label + '\\');
            wdataList.push(data[i]);
        }
        return wdataList;     
    }

    private updateTreeFromPath(data, aParent) {
        data.expanded = this.getExpanded(data.selpath, data);
        data.selpath = '';
        data.parent = aParent;
        if (data.children !== undefined) {
            data.children.map((item) => {
                item.expanded = this.getExpanded(item.selpath, item);
                item.selpath = '';
                if (item.children !== undefined) {
                    item.children.map((elem) => {
                        this.updateTreeFromPath(elem, item);
                    });
                }
            });
        }
    }

    private initializeTree(data) {
        data.expandedIcon = 'pi pi-folder-open';
        data.collapsedIcon = 'pi pi-folder';
        data.expanded = false;
        data.selpath = '';
        if (data.children !== undefined) {
            data.children.map((item) => {
                item.expandedIcon = 'pi pi-folder-open';
                item.collapsedIcon = 'pi pi-folder';
                item.expanded = false;
                item.selpath = '';
                if (item.children !== undefined) {
                    item.children.map((elem) => {
                        this.initializeTree(elem);
                    });
                }
            });
        }
    }

    private getExpanded(aSelpath, aItem) {
        let wIndex = -1;
        wIndex = aSelpath.length;
        if (this.openPath.substring(0, wIndex) === aSelpath) {
            this.prevExpand = this.lastExpand;
            this.lastExpand = aItem.key;
            this.lastNode = aItem;
            return true;
        } else {
            return false;
        }
    }

    private setPath(data, aLabel) {
        if (aLabel !== '') {
            data.selpath += aLabel;
        }
        if (data.children !== undefined) {
            data.children.map((item) => {
                item.selpath = data.selpath + item.label + '\\';
                if (item.children !== undefined) {
                    item.children.map((elem) => {
                        this.setPath(elem, item.selpath + elem.label + '\\');
                    });
                }
            });
        }
    }

    public updateSearchPath() {
        let wPath = '';
        wPath = this.openPath.replace(/\\/g, '/');
        return wPath;
    }

    public getRootPath(aPath) {
        let root = '';
        let path = '';
        let arrayPath = [];
        let wPath = aPath.replace(/\\/g, '/');
        arrayPath = wPath.split('/');
        root = arrayPath[0];
        for (let i = 1; i < arrayPath.length; i++) {
            if (arrayPath[i] !== '') {
                path = path + arrayPath[i] + '\\';
            }
        }
        return {
            root: root,
            path: path,
        };
    }

    public initRootPath() {
        return {
            root: '',
            path: '',
        };
    }

    public formatRequestTree(apath, aVariableList, aResultList, aCount, aSearchWord) {
        let rootPath = this.getRootPath(apath);
        let wRequest = {
            CountDoc: aCount,
            Browse: { Root: rootPath.root, Path: rootPath.path, ResultList: aResultList },
            SearchWord: encodeUtf8(aSearchWord),
        };
        return wRequest;
    }

    public expandRecursive(node: TreeNode, isExpand: boolean) {
        node.expanded = isExpand;
        if (node.children) {
            node.children.forEach((childNode) => {
                this.expandRecursive(childNode, isExpand);
            });
        }
    }
}
